import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    DataElementoClienteHistorial: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_DATA_ELEMENTO_CLIENTE_HISTORIAL = 'GET_ALL_DATA_ELEMENTO_CLIENTE_HISTORIAL'
const GET_DATA_ELEMENTO_CLIENTE_HISTORIAL_BY_ID = 'GET_DATA_ELEMENTO_CLIENTE_HISTORIAL_BY_ID'
const POST_DATA_ELEMENTO_CLIENTE_HISTORIAL = 'POST_DATA_ELEMENTO_CLIENTE_HISTORIAL'
const UPDATE_DATA_ELEMENTO_CLIENTE_HISTORIAL = 'UPDATE_DATA_ELEMENTO_CLIENTE_HISTORIAL'
const DELETE_DATA_ELEMENTO_CLIENTE_HISTORIAL = 'DELETE_DATA_ELEMENTO_CLIENTE_HISTORIAL'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllDataElementoClienteHistorial = createAsyncThunk(
    GET_ALL_DATA_ELEMENTO_CLIENTE_HISTORIAL,
    async () => {
        try {
            const fullUrl = host + `DataElementoClienteHistorial/obtenerDataElementosClienteHistorial`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las DataElementoClienteHistorials: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getDataElementoClienteHistorialById = createAsyncThunk(
    GET_DATA_ELEMENTO_CLIENTE_HISTORIAL_BY_ID,
    async (idDataElementoClienteHistorial) => {
        try {
            const fullUrl = host + `DataElementoClienteHistorial/obtenerDataElementoClienteHistorialById/${idDataElementoClienteHistorial}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertDataElementoClienteHistorial = createAsyncThunk(
    POST_DATA_ELEMENTO_CLIENTE_HISTORIAL,
    async (data) => {
        try {
            const fullUrl = host + `DataElementoClienteHistorial/agregarDataElementoClienteHistorial`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateDataElementoClienteHistorial = createAsyncThunk(
    UPDATE_DATA_ELEMENTO_CLIENTE_HISTORIAL,
    async (data) => {
        try {
            const fullUrl = host + `DataElementoClienteHistorial/actualizarDataElementoClienteHistorial`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteDataElementoClienteHistorial = createAsyncThunk(
    DELETE_DATA_ELEMENTO_CLIENTE_HISTORIAL,
    async (idDataElementoClienteHistorial) => {
        try {
            const fullUrl = host + `DataElementoClienteHistorial/eliminarDataElementoClienteHistorial/${idDataElementoClienteHistorial}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosDataElementoClienteHistorialSlice = createSlice({

    name: 'metodosDataElementoClienteHistorialSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllDataElementoClienteHistorial.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.DataElementoClienteHistorial = payload.data.data

        },
        [getDataElementoClienteHistorialById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.DataElementoClienteHistorial = payload.data.data
        },
        [insertDataElementoClienteHistorial.fulfilled]: (state, { payload }) => {
            state.DataElementoClienteHistorial = payload.data.data
        },

        [updateDataElementoClienteHistorial.fulfilled]: (state, { payload }) => {

        },
        [deleteDataElementoClienteHistorial.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosDataElementoClienteHistorialSlice.actions
export const DataElementoClienteHistorialReducer = metodosDataElementoClienteHistorialSlice.reducer